/* ============================================================================
FILE: po-katupirsia5-sceau-ayeemi-texts-fr-en-es-20260312.js

MODE: TRILINGUE (FR/EN/ES) + protection lexique simplifié (si dispo)
API:  window.PoK5SceauAyeemiTextsFR_EN_ES_20260312

ROOT: .po-axis-section[data-po-axis="sceau_ayeemi"]

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue (storage puis navigateur).
  - IMPORTANT: les termes du lexique (et variantes) restent en FR, quelle que soit la langue affichée.
  - Protection fine: verrouille (translate="no") les occurrences du lexique simplifié (si dispo),
    avec variantes apostrophes + œ/oe, et anti-collage.
  - Compat: expose window.GoodyTwinLang (getLang/setLang/init) pour compat anciens appels.
  - Ajoute une couche audio locale et générale sans toucher au socle multilingue,
    ni au nom du fichier.
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_K5_SCEAU_AYEEMI_TEXTS_20260312__) return;
  window.__PO_K5_SCEAU_AYEEMI_TEXTS_20260312__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var AXIS_LEX_ID = "sceau_ayeemi";
  var ROOT_SEL =
    '.po-axis-section[data-po-axis="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-lex-id="' + AXIS_LEX_ID + '"]';

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aye_mi_111_2.png?v=1772902150";
  var IMG_IDEOGRAM_FUNCTION = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aye_mi_111_3_copie_2.png?v=1772902473";
  var IMG_ENTITY = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Aye_mine_2_copie.png?v=1772923595";
  var IMG_FREQ_111 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_111.png?v=1773449250";

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang(){
    try{
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    }catch(e){}
    try{
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    }catch(e){}
    return "";
  }

  function storeLang(lang){
    var v = normLang(lang) || "fr";
    try{ localStorage.setItem(STORAGE_KEY, v); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, v); }catch(e){}
    try{ document.documentElement.setAttribute("lang", v); }catch(e){}
    return v;
  }

  function detectBrowserLang(){
    try{
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    }catch(e){}
    return "fr";
  }

  function getLang(){
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine
   * -------------------------------------------------------------------------- */

  function protectSpan(txt){
    return '<span translate="no" class="po-lex-protect notranslate">' + clampStr(txt) + "</span>";
  }

  function uniqPush(arr, v){
    if (!v) return;
    for (var i=0;i<arr.length;i++) if (arr[i] === v) return;
    arr.push(v);
  }

  function buildVariants(term){
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);

    var a1 = t.replace(/’/g, "'");
    var a2 = t.replace(/'/g, "’");
    uniqPush(out, a1);
    uniqPush(out, a2);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1);
    uniqPush(out, oe2);
    uniqPush(out, oe1.replace(/’/g, "'"));
    uniqPush(out, oe1.replace(/'/g, "’"));
    uniqPush(out, oe2.replace(/’/g, "'"));
    uniqPush(out, oe2.replace(/'/g, "’"));

    var lower = t.toLowerCase();
    if (lower !== t){
      uniqPush(out, lower);
      uniqPush(out, lower.replace(/’/g, "'"));
      uniqPush(out, lower.replace(/'/g, "’"));
      uniqPush(out, lower.replace(/œ/g, "oe"));
      uniqPush(out, lower.replace(/oe/g, "œ"));
    }

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        return window.PO_LEXICON.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (window.PO_LEXIQUE_SIMPLIFIE && window.PO_LEXIQUE_SIMPLIFIE.meta && Array.isArray(window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr)){
        return window.PO_LEXIQUE_SIMPLIFIE.meta.lexique_simplifie_fr.slice();
      }
    }catch(e){}
    try{
      if (Array.isArray(window.PO_LEXIQUE_SIMPLIFIE_FR)){
        return window.PO_LEXIQUE_SIMPLIFIE_FR.slice();
      }
    }catch(e){}

    return [
      "Posœnnoïsme","Posœnnoïa","Organon posœnnoïal","Katûvýs","Katûvýsissence",
      "Katûsýs","Katûvýsqun","Balakallpa","Isqun","Threnisqun","Ennéagone","Ennéagone régulateur",
      "Sceau d’Équiphase","Sceau de Syntonie","Sceau d’Aísthisi","Sceau d’Anépôron","Sceau d’Ìfẹ","Sceau d’Ifẹ̀",
      "Sceau d’Ayeẹmí","Ayeẹmí","Ayeẹmīnê","RéZonans","Aliœvolution","Péroptissimisme","Illusion",
      "Addition synchrêtique","Instantané multiple","Superposition de perspectives","Sujet pluriel",
      "Tiqqunbahu","Ušôprogalenmestûd","Posœnnomia","Katûpirsia"
    ];
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function buildProtectMatcher(){
    var base = getSimplifiedLexiqueFRList();
    var variants = [];
    for (var i=0;i<base.length;i++){
      var vlist = buildVariants(base[i]);
      for (var j=0;j<vlist.length;j++) uniqPush(variants, vlist[j]);
    }
    variants.sort(function(a,b){ return b.length - a.length; });
    var parts = [];
    for (var k=0;k<variants.length;k++) if (variants[k]) parts.push(escapeRegExp(variants[k]));
    if (!parts.length) return null;
    try{ return new RegExp("(" + parts.join("|") + ")", "g"); }catch(e){ return null; }
  }

  var __PO_PROTECT_RE__ = null;

  function protectKeywordsHTML(html){
    if (!html) return "";
    var out = String(html);
    if (!__PO_PROTECT_RE__) __PO_PROTECT_RE__ = buildProtectMatcher();
    if (__PO_PROTECT_RE__){
      out = out.replace(__PO_PROTECT_RE__, function(m){ return protectSpan(m); });
    }
    out = out.replace(/([0-9A-Za-zÀ-ÖØ-öø-ÿ])(<span translate="no" class="po-lex-protect notranslate">)/g, "$1 $2");
    out = out.replace(/(<\/span>)([0-9A-Za-zÀ-ÖØ-öø-ÿ])/g, "$1 $2");
    out = out.replace(/(<\/span>)(<[^\/\s>])/g, "$1 $2");
    out = out.replace(/([^\s>])(<span translate="no" class="po-lex-protect notranslate">)/g, function(_m, a, b){
      if (a === " " || a === ">") return a + b;
      return a + " " + b;
    });
    return out;
  }

  /* --------------------------------------------------------------------------
   * SLOTS helpers
   * -------------------------------------------------------------------------- */

  function qs(root, sel){
    try{ return root.querySelector(sel); }catch(e){ return null; }
  }

  function setSlotText(root, slot, txt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setSlotHTML(root, slot, html){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(clampStr(html));
  }

  function setSlotImg(root, slot, src, alt){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var s = clampStr(src);
    var a = clampStr(alt);
    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt",""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }
    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function renderList(root, slot, items){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++) out.push("<li>" + protectKeywordsHTML(clampStr(arr[i])) + "</li>");
    el.innerHTML = out.join("");
  }

  function renderExampleBox(root, slot, exampleTitle, exampleText){
    var el = qs(root, '[data-po-slot="'+slot+'"]');
    if (!el) return;
    var t = clampStr(exampleTitle);
    var x = clampStr(exampleText);
    if (!t && !x){ el.innerHTML = ""; return; }
    var html =
      '<div class="po-lex-example__title"><strong>' + protectKeywordsHTML(t) + '</strong></div>' +
      '<div class="po-lex-example__text">' + protectKeywordsHTML(x) + "</div>";
    el.innerHTML = html;
  }

  function renderWordBlocks(root, slot, blocks){
    var host = qs(root, '[data-po-slot="'+slot+'"]');
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = clampStr(b.head || "");
      var t = clampStr(b.text || "");
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(h) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(t).replace(/\n/g, "<br />") + '</div>' +
        '</div>'
      );
    }
    host.innerHTML = out.join("");
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:"", lang:"fr", voice:null };
  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){ var L = normLang(lang); return AUDIO_UI[L] || AUDIO_UI.fr; }
  function getAudioRoots(){ try{ return document.querySelectorAll(ROOT_SEL); }catch(e){ return []; } }
  function getDetailBlocks(root){ if (!root || !root.querySelectorAll) return []; try{ return root.querySelectorAll('.po-lex-details'); }catch(e){ return []; } }

  function ensureAudioStyles(){
    if (document.getElementById('po-axis-audio-styles')) return;
    var style = document.createElement('style');
    style.id = 'po-axis-audio-styles';
    style.textContent =
      '.po-axis-audio-wrap{display:flex;align-items:center;gap:.6rem;margin:1rem 0 1.15rem 0;justify-content:flex-start;}' +
      '.po-axis-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(184,134,11,.55);background:rgba(31,122,58,.04);color:var(--color-accent,#1f7a3a);padding:.55rem .9rem;border-radius:999px;cursor:pointer;font:inherit;font-weight:800;line-height:1.2;transition:opacity .2s ease,transform .2s ease,box-shadow .2s ease,border-color .2s ease;box-shadow:0 6px 16px rgba(31,122,58,.10);}' +
      '.po-axis-audio-btn:hover{transform:translateY(-1px);box-shadow:0 10px 26px rgba(31,122,58,.16);border-color:rgba(184,134,11,.75);}' +
      '.po-axis-audio-btn[aria-pressed="true"]{box-shadow:0 0 0 1px rgba(184,134,11,.18),0 10px 26px rgba(31,122,58,.18);background:rgba(31,122,58,.08);}' +
      '.po-lex-summary .po-axis-audio-btn{margin-left:.75rem;vertical-align:middle;flex:0 0 auto;}' +
      '@media (max-width:640px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{display:block;margin:.65rem 0 0 0;}}';
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-axis-audio-btn';
    btn.setAttribute('data-po-audio-role', role === 'general' ? 'general' : 'detail');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('translate', 'yes');
    return btn;
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();
    var panel = root.querySelector('.po-lex-panel');
    if (panel){
      var generalWrap = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]');
      if (!generalWrap){
        generalWrap = document.createElement('div');
        generalWrap.className = 'po-axis-audio-wrap';
        generalWrap.setAttribute('data-po-audio-role', 'general');
        generalWrap.appendChild(createAudioButton('general'));

        var meta = root.querySelector('.po-axis-meta');
        var defShort = root.querySelector('[data-po-slot="def_short"]');
        var firstDetail = panel.querySelector('.po-lex-details');
        if (meta && meta.parentNode){
          if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
          else meta.parentNode.appendChild(generalWrap);
        } else if (defShort && defShort.parentNode){
          defShort.parentNode.insertBefore(generalWrap, defShort);
        } else if (firstDetail && firstDetail.parentNode){
          firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
        } else {
          panel.appendChild(generalWrap);
        }
      }
    }

    var details = getDetailBlocks(root);
    for (var i=0;i<details.length;i++){
      var summary = details[i].querySelector('.po-lex-summary');
      if (!summary) continue;
      var btn = summary.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"]');
      if (!btn){
        btn = createAudioButton('detail');
        summary.appendChild(btn);
      }
      btn.setAttribute('data-po-audio-index', String(i));
    }
  }

  function getTextValue(el){
    if (!el) return '';
    var txt = '';
    try{ txt = el.innerText || el.textContent || ''; }catch(e){ txt = ''; }
    return String(txt).replace(/\s+/g, ' ').replace(/\u00a0/g, ' ').trim();
  }

  function removeAudioButtonsFromClone(root){
    if (!root || !root.querySelectorAll) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn, .po-axis-audio-wrap');
    for (var i=0;i<btns.length;i++) if (btns[i] && btns[i].parentNode) btns[i].parentNode.removeChild(btns[i]);
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ['title','kicker','h_def','def_short','def_long'];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = getTextValue(el);
      if (txt) parts.push(txt);
    }
    return parts.join('. ');
  }

  function collectDetailText(detail){
    if (!detail) return '';
    var parts = [];
    var title = detail.querySelector('.po-lex-summary__title');
    var titleText = getTextValue(title);
    if (titleText) parts.push(titleText);
    var clone = detail.cloneNode(true);
    var summary = clone.querySelector('.po-lex-summary');
    if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
    removeAudioButtonsFromClone(clone);
    var bodyText = getTextValue(clone);
    if (bodyText) parts.push(bodyText);
    return parts.join('. ');
  }

  function isWordLikeChar(ch){ return /[0-9A-Za-zÀ-ÖØ-öø-ÿ]/.test(ch || ''); }

  function splitTextForSpeech(txt, maxLen){
    var text = clampStr(txt).replace(/\s+/g, ' ').trim();
    if (!text) return [];
    var limit = Math.max(120, parseInt(maxLen, 10) || 200);
    var out = [];
    var start = 0;
    while (start < text.length){
      var end = Math.min(start + limit, text.length);
      if (end < text.length){
        var slice = text.slice(start, end);
        var cut = Math.max(slice.lastIndexOf('. '), slice.lastIndexOf('! '), slice.lastIndexOf('? '), slice.lastIndexOf('; '), slice.lastIndexOf(': '), slice.lastIndexOf(', '));
        if (cut < Math.floor(limit * 0.55)) cut = slice.lastIndexOf(' ');
        if (cut > 0) end = start + cut + 1;
      }
      while (end < text.length && isWordLikeChar(text.charAt(end - 1)) && isWordLikeChar(text.charAt(end))) end++;
      var chunk = text.slice(start, end).trim();
      if (chunk) out.push(chunk);
      start = end;
    }
    return out;
  }

  function pickVoiceForLang(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== 'function') return null;
    var wanted = normLang(lang) || 'fr';
    var voices = [];
    try{ voices = PO_AUDIO_SYNTH.getVoices() || []; }catch(e){ voices = []; }
    if (!voices.length) return null;
    for (var i=0;i<voices.length;i++) if (normLang(voices[i] && voices[i].lang) === wanted) return voices[i];
    for (var j=0;j<voices.length;j++){
      var voiceLang = clampStr(voices[j] && voices[j].lang).toLowerCase();
      if (voiceLang.indexOf(wanted) === 0) return voices[j];
    }
    return voices[0] || null;
  }

  function buildUnits(root, role, index){
    var units = [];
    var details = getDetailBlocks(root);
    if (role === 'general'){
      units.push({ role:'general', index:-1 });
      for (var i=0;i<details.length;i++) units.push({ role:'detail', index:i });
      return units;
    }
    var start = (typeof index === 'number' && index >= 0) ? index : 0;
    for (var j=start;j<details.length;j++) units.push({ role:'detail', index:j });
    return units;
  }

  function updateAudioPressedState(){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      var btns = roots[i].querySelectorAll('.po-axis-audio-btn');
      for (var j=0;j<btns.length;j++) btns[j].setAttribute('aria-pressed','false');
    }
    if (!PO_AUDIO_STATE.root || !PO_AUDIO_STATE.activeKey) return;
    var btn;
    if (PO_AUDIO_STATE.activeKey === 'general'){
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
      if (btn) btn.setAttribute('aria-pressed','true');
      return;
    }
    var idx = parseInt(String(PO_AUDIO_STATE.activeKey).split(':')[1], 10);
    if (!isNaN(idx)){
      btn = PO_AUDIO_STATE.root.querySelector('.po-axis-audio-btn[data-po-audio-role="detail"][data-po-audio-index="' + idx + '"]');
      if (btn) btn.setAttribute('aria-pressed','true');
    }
  }

  function refreshAudioLabels(root, lang){
    if (!root) return;
    var ui = audioUI(lang || getLang());
    var generalBtn = root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"] .po-axis-audio-btn[data-po-audio-role="general"]');
    if (generalBtn){
      var generalActive = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === 'general' && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      generalBtn.textContent = generalActive ? ui.stop : ui.general;
    }
    var detailBtns = root.querySelectorAll('.po-axis-audio-btn[data-po-audio-role="detail"]');
    for (var i=0;i<detailBtns.length;i++){
      var btn = detailBtns[i];
      var idx = parseInt(btn.getAttribute('data-po-audio-index'), 10);
      var key = 'detail:' + (isNaN(idx) ? -1 : idx);
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending));
      btn.textContent = active ? ui.stop : ui.block;
    }
    updateAudioPressedState();
  }

  function refreshAllAudioLabels(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++) refreshAudioLabels(roots[i], lang || getLang());
  }

  function stopAudio(silent){
    if (PO_AUDIO_SYNTH){ try{ PO_AUDIO_SYNTH.cancel(); }catch(e){} }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.voice = null;
    if (!silent) refreshAllAudioLabels(getLang()); else updateAudioPressedState();
  }

  function speakCurrentChunk(){
    if (!PO_AUDIO_SYNTH) return;
    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos < 0 || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      playCurrentUnit(true);
      return;
    }
    var txt = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!txt){ PO_AUDIO_STATE.chunkPos += 1; speakCurrentChunk(); return; }
    var utter = new SpeechSynthesisUtterance(txt);
    utter.lang = (PO_AUDIO_STATE.lang || getLang() || 'fr');
    if (PO_AUDIO_STATE.voice) utter.voice = PO_AUDIO_STATE.voice;
    utter.onend = function(){ PO_AUDIO_STATE.chunkPos += 1; speakCurrentChunk(); };
    utter.onerror = function(){ PO_AUDIO_STATE.chunkPos += 1; speakCurrentChunk(); };
    try{ PO_AUDIO_SYNTH.speak(utter); }catch(e){ PO_AUDIO_STATE.chunkPos += 1; speakCurrentChunk(); }
  }

  function playCurrentUnit(skipCancel){
    if (!PO_AUDIO_SYNTH) return;
    if (!skipCancel){ try{ PO_AUDIO_SYNTH.cancel(); }catch(e){} }
    if (!PO_AUDIO_STATE.root || PO_AUDIO_STATE.unitPos < 0 || PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){ stopAudio(); return; }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (!unit){ stopAudio(); return; }

    var text = '';
    if (unit.role === 'general'){
      PO_AUDIO_STATE.activeKey = 'general';
      text = collectGeneralText(PO_AUDIO_STATE.root);
    } else {
      PO_AUDIO_STATE.activeKey = 'detail:' + unit.index;
      var details = getDetailBlocks(PO_AUDIO_STATE.root);
      var detail = details[unit.index];
      if (detail){ try{ detail.open = true; }catch(e){} }
      text = collectDetailText(detail);
    }

    PO_AUDIO_STATE.chunks = splitTextForSpeech(text, 210);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAllAudioLabels(PO_AUDIO_STATE.lang || getLang());
    if (!PO_AUDIO_STATE.chunks.length){ PO_AUDIO_STATE.unitPos += 1; playCurrentUnit(true); return; }
    speakCurrentChunk();
  }

  function startAudio(root, role, index){
    if (!PO_AUDIO_SYNTH || !root) return;
    stopAudio(true);
    var lang = getLang();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, role, index);
    PO_AUDIO_STATE.unitPos = 0;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    PO_AUDIO_STATE.lang = lang;
    PO_AUDIO_STATE.voice = pickVoiceForLang(lang);
    refreshAllAudioLabels(lang);
    playCurrentUnit(false);
  }

  function bindAudioButtons(root){
    if (!root) return;
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i=0;i<btns.length;i++){
      if (btns[i].__poAudioBound) continue;
      btns[i].addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = this.getAttribute('data-po-audio-role') || 'detail';
        var index = parseInt(this.getAttribute('data-po-audio-index'), 10);
        var key = (role === 'general') ? 'general' : ('detail:' + (isNaN(index) ? -1 : index));
        var sameRoot = (PO_AUDIO_STATE.root === root);
        var sameKey = (PO_AUDIO_STATE.activeKey === key);
        if (sameRoot && sameKey && PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending)){
          stopAudio();
          return;
        }
        startAudio(root, role, isNaN(index) ? -1 : index);
      });
      btns[i].__poAudioBound = true;
    }
  }

  function initAudioEverywhere(lang){
    var roots = getAudioRoots();
    for (var i=0;i<roots.length;i++){
      ensureAudioButtons(roots[i]);
      bindAudioButtons(roots[i]);
      refreshAudioLabels(roots[i], lang || getLang());
    }
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.addEventListener === 'function'){
      PO_AUDIO_SYNTH.addEventListener('voiceschanged', function(){
        if (PO_AUDIO_STATE.root) PO_AUDIO_STATE.voice = pickVoiceForLang(PO_AUDIO_STATE.lang || getLang());
      });
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * TEXTES TRI — Sceau d’Ayeẹmí
   * -------------------------------------------------------------------------- */

  var TEXTS = {
    fr: {
      title: "Sceau d’Ayeẹmí",
      kicker:
        'Isqun — Ennéagone régulateur<br />Régulation des résidus atemporels (ancestralités non intégrées, mémoires dissociées)',
      h_def: "Définition essentielle",
      chips: ["Idéogramme fonctionnel", "Ayeẹmīnê", "Fréquence harmonique 111"],
      def_short:
        "Régulateur des charges mémorielles atemporelles (ancestrales, karmiques, dissociées) ; seuil de désaturation et de libération mémorielle.",
      def_long:
        "Le Sceau d’Ayeẹmí est le régulateur vibratoire des charges mémorielles atemporelles, lorsque le temps humain n’a pas pu tout intégrer. Il agit comme un point de désintégration des nœuds généalogiques invisibles, un filtre des souvenirs karmiques non transmutés et un dénoueur des traces dissociées de la conscience ordinaire.\n\n" +
        "Il ne cherche pas la réintégration immédiate, mais opère une déprogrammation spiralée, permettant à ces mémoires de trouver leur propre rythme d’évaporation ou de résurgence, selon la nécessité du vivant.\n\n" +
        "Le Sceau d’Ayeẹmí relie les mémoires humaines non intégrées à la fluidité temporelle cosmique. Il ouvre une intégration différée qui rend la lignée respirable et réactivable sans répétition.",
      h_features: "Fonction (développée) & paramètres",
      hint_fold: "déplier",
      features: [
        "<strong>Statut</strong> : Sceau régulateur de l’Ennéagone spiralé (Isqun).",
        "<strong>Lien matriciel</strong> : relie les mémoires humaines non intégrées à la fluidité temporelle cosmique.",
        "<strong>Fonction principale</strong> : régulation des résidus karmiques, mémoriels et ancestraux non résolus.",
        "<strong>Nature</strong> : ni Katûsýs, ni Balakallpa, ni Katûvýsqun — intégré à la Katûvýs comme interface d’intégration différée.",
        "<strong>Type</strong> : spirale de libération mémorielle.",
        "<strong>Régime</strong> : désintrication lente, intégration différée (sans forcing cognitif).",
        "<strong>Fréquence harmonique</strong> : 111 (73 « Sceau » + 38 « Ayeẹmí »)."
      ],
      h_questions: "Tests d’usage (ultra-pratiques)",
      hint_fold2: "déplier",
      questions: [
        'Si un trouble agit “sans cause” dans le présent : <em>« Ayeẹmí écoute »</em>.',
        'Si une répétition de lignée revient en boucle : <em>« Ayeẹmí désintrique »</em>.',
        'Si la mémoire invisible doit redevenir circulation : <em>« Ayeẹmí libère »</em>.'
      ],
      example_title: "Séquence rituelle canonique",
      example:
        "1) Identifier une résonance ancestrale ou un trouble karmique diffus.\n" +
        "2) Entrer dans un espace d’écoute flottante (sans attente).\n" +
        "3) Activer une image intérieure : un souffle pénétrant les strates invisibles.\n" +
        "4) Laisser le Sceau agir sans chercher à interpréter, ni à comprendre.\n" +
        "5) Clôturer par la phrase vibratoire : « Ce qui fut n’a pas disparu. Ce qui vient n’est pas encore. Je relie. »",
      h_family: "Position systémique & correspondances",
      hint_fold3: "déplier",
      family_1:
        "<p><strong>Position dans la Katûvýs :</strong> le Sceau d’Ayeẹmí siège dans la zone d’interface entre la Katûvýs et les champs mémoriels non structurés. Il ne régule pas l’axe du présent, mais traverse les spirales de mémoire, là où l’oubli et la rémanence dialoguent.</p>",
      family_2:
        "<p><strong>Entité correspondante :</strong> <span translate=\"no\" class=\"po-lex-protect notranslate\">Ayeẹmīnê</span> (111), émanation isqunienne de transmutation des mémoires atemporelles : elle accueille, active, libère, et retisse la mémoire en vortex doux d’intégration poïétique.</p>",
      h_wordbuild: "Formation du nom & lecture opérative",
      word_blocks: [
        {
          head: "Ancrage yorùbá (fonctionnel)",
          text:
            "Ayé : monde, plan d’existence.\n" +
            "Ẹmí : souffle, esprit.\n" +
            "Ayeẹmí désigne une mémoire qui respire dans le monde, persistante tant qu’un passage de syntonie n’a pas été ouvert."
        },
        {
          head: "Lecture vibratoire 111",
          text:
            "Triple unité : alignement tripolaire.\n" +
            "Mémoire du corps / Mémoire du souffle / Mémoire du sens.\n" +
            "Régulation par respiration étagée plutôt que par choc interprétatif."
        },
        {
          head: "Fonctionnement rituelo-symbolique",
          text:
            "Le Sceau d’Ayeẹmí intervient là où le corps, l’histoire ou la lignée portent des charges invisibles non reliées aux cycles du présent. Il propose une transmutation spiralée différée, respectueuse du rythme vibratoire de chaque mémoire."
        },
        {
          head: "Portée opérative",
          text:
            "Le Sceau n’efface pas. Il ne guérit pas par rappel. Il réoriente le souffle mémoriel afin que l’invisible cesse de peser en bloc et redevienne circulation."
        }
      ],
      word_notes: [
        "Syntonies utiles : Katûvýsissence, Tiqqunbahu, Ušôprogalenmestûd, Posœnnomia.",
        "Mode d’invocation associé à Ayeẹmīnê : terre — souffle — souvenir non verbalisé.",
        "Conseil d’usage : laisser agir le Sceau sans chercher à comprendre sur-le-champ ; la libération suit un rythme différé."
      ],
      cta_translate: "Proposer une traduction du concept"
    },
    en: {
      title: "Sceau d’Ayeẹmí",
      kicker:
        "Isqun — Ennéagone régulateur<br />Regulation of atemporal residues (unintegrated ancestry, dissociated memories)",
      h_def: "Essential definition",
      chips: ["Functional ideogram", "Ayeẹmīnê", "Harmonic frequency 111"],
      def_short:
        "Sceau d’Ayeẹmí regulates atemporal memorial charges (ancestral, karmic, dissociated); a threshold for desaturation and memorial release.",
      def_long:
        "Sceau d’Ayeẹmí is the vibratory regulator of atemporal memorial charges whenever human time could not integrate everything. It acts as a point of disintegration for invisible genealogical knots, a filter for untransmuted karmic memories, and an untier of traces dissociated from ordinary consciousness.\n\n" +
        "It does not seek immediate reintegration, but operates through spiral deprogramming, allowing these memories to find their own rhythm of evaporation or resurgence according to the necessity of the living.\n\n" +
        "Sceau d’Ayeẹmí connects unintegrated human memories to cosmic temporal fluidity. It opens a deferred integration through which lineage becomes breathable and reactivable without repetition.",
      h_features: "Developed function & parameters",
      hint_fold: "expand",
      features: [
        "<strong>Status</strong> : Sceau régulateur de l’Ennéagone spiralé (Isqun).",
        "<strong>Matrix link</strong> : connects unintegrated human memories to cosmic temporal fluidity.",
        "<strong>Main function</strong> : regulation of unresolved karmic, memorial and ancestral residues.",
        "<strong>Nature</strong> : ni Katûsýs, ni Balakallpa, ni Katûvýsqun — intégré à la Katûvýs comme interface d’intégration différée.",
        "<strong>Type</strong> : memorial-release spiral.",
        "<strong>Regime</strong> : slow disentanglement, deferred integration (no cognitive forcing).",
        "<strong>Harmonic frequency</strong> : 111 (73 “Sceau” + 38 “Ayeẹmí”)."
      ],
      h_questions: "Ultra-practical usage tests",
      hint_fold2: "expand",
      questions: [
        'If a trouble acts “without cause” in the present: <em>“Ayeẹmí listens.”</em>',
        'If a lineage repetition loops back: <em>“Ayeẹmí disentangles.”</em>',
        'If invisible memory must become circulation again: <em>“Ayeẹmí releases.”</em>'
      ],
      example_title: "Canonical ritual sequence",
      example:
        "1) Identify a diffuse ancestral resonance or karmic disturbance.\n" +
        "2) Enter a floating listening state, without demanding explanation.\n" +
        "3) Activate the inner image: a breath crossing invisible strata.\n" +
        "4) Let the Sceau act without trying to interpret or understand.\n" +
        "5) Close with: “What was has not vanished. What comes is not yet. I link.”",
      h_family: "Systemic position & correspondences",
      hint_fold3: "expand",
      family_1:
        "<p><strong>Position in Katûvýs :</strong> Sceau d’Ayeẹmí stands at the interface between Katûvýs and unstructured memorial fields. It does not regulate the axis of the present; it traverses spirals of memory where forgetting and persistence remain in dialogue.</p>",
      family_2:
        "<p><strong>Corresponding entity :</strong> <span translate=\"no\" class=\"po-lex-protect notranslate\">Ayeẹmīnê</span> (111), an isqunian emanation of transmutation for atemporal memories: it receives, activates, releases, and rewrites memory as a gentle vortex of poietic integration.</p>",
      h_wordbuild: "Name formation & operative reading",
      word_blocks: [
        {
          head: "Functional yorùbá anchoring",
          text:
            "Ayé: world, plane of existence.\n" +
            "Ẹmí: breath, spirit.\n" +
            "Ayeẹmí names a memory breathing in the world, remaining active until a passage of syntony has been opened."
        },
        {
          head: "Vibratory reading 111",
          text:
            "Triple unity: a three-pole alignment.\n" +
            "Body-memory / Breath-memory / Sense-memory.\n" +
            "Regulation by staged breathing rather than interpretive shock."
        },
        {
          head: "Ritual-symbolic functioning",
          text:
            "Sceau d’Ayeẹmí intervenes where body, history, or lineage carry invisible charges not linked to the cycles of the present. It proposes a deferred spiral transmutation, respectful of the vibratory rhythm of each memory."
        },
        {
          head: "Operative scope",
          text:
            "The Sceau does not erase. It does not heal by recall. It reorients memorial breath so that the invisible no longer weighs as a block and becomes circulation again."
        }
      ],
      word_notes: [
        "Useful syntonies: Katûvýsissence, Tiqqunbahu, Ušôprogalenmestûd, Posœnnomia.",
        "Invocation mode associated with Ayeẹmīnê: earth — breath — unverbalised memory.",
        "Use: let the Sceau act without trying to solve immediately; release follows a deferred rhythm."
      ],
      cta_translate: "Suggest a translation of the concept"
    },
    es: {
      title: "Sceau d’Ayeẹmí",
      kicker:
        "Isqun — Ennéagone régulateur<br />Regulación de residuos atemporales (ancestralidades no integradas, memorias disociadas)",
      h_def: "Definición esencial",
      chips: ["Ideograma funcional", "Ayeẹmīnê", "Frecuencia armónica 111"],
      def_short:
        "Sceau d’Ayeẹmí regula las cargas memoriales atemporales (ancestrales, kármicas, disociadas); umbral de desaturación y de liberación memorial.",
      def_long:
        "Sceau d’Ayeẹmí es el regulador vibratorio de las cargas memoriales atemporales cuando el tiempo humano no ha podido integrarlo todo. Actúa como punto de desintegración de nudos genealógicos invisibles, filtro de recuerdos kármicos no transmutados y desanudador de huellas disociadas de la conciencia ordinaria.\n\n" +
        "No busca una reintegración inmediata, sino que opera por desprogramación espiral, permitiendo a estas memorias encontrar su propio ritmo de evaporación o de resurgencia, según la necesidad de lo viviente.\n\n" +
        "Sceau d’Ayeẹmí conecta las memorias humanas no integradas con la fluidez temporal cósmica. Abre una integración diferida para que el linaje se vuelva respirable y reactivable sin repetición.",
      h_features: "Función desarrollada y parámetros",
      hint_fold: "desplegar",
      features: [
        "<strong>Estatus</strong> : Sceau régulateur de l’Ennéagone spiralé (Isqun).",
        "<strong>Vínculo matricial</strong> : conecta las memorias humanas no integradas con la fluidez temporal cósmica.",
        "<strong>Función principal</strong> : regulación de residuos kármicos, memoriales y ancestrales no resueltos.",
        "<strong>Naturaleza</strong> : ni Katûsýs, ni Balakallpa, ni Katûvýsqun — intégré à la Katûvýs comme interface d’intégration différée.",
        "<strong>Tipo</strong> : espiral de liberación memorial.",
        "<strong>Régimen</strong> : desintricación lenta, integración diferida (sin forcing cognitivo).",
        "<strong>Frecuencia armónica</strong> : 111 (73 “Sceau” + 38 “Ayeẹmí”)."
      ],
      h_questions: "Tests de uso (ultra-prácticos)",
      hint_fold2: "desplegar",
      questions: [
        'Si un malestar actúa “sin causa” en el presente: <em>«Ayeẹmí escucha»</em>.',
        'Si una repetición del linaje vuelve en bucle: <em>«Ayeẹmí desintrica»</em>.',
        'Si la memoria invisible debe volver a ser circulación: <em>«Ayeẹmí libera»</em>.'
      ],
      example_title: "Secuencia ritual canónica",
      example:
        "1) Identificar una resonancia ancestral o un trastorno kármico difuso.\n" +
        "2) Entrar en una escucha flotante, sin exigir explicación.\n" +
        "3) Activar la imagen interior: un aliento que atraviesa estratos invisibles.\n" +
        "4) Dejar actuar el Sceau sin buscar interpretar ni comprender.\n" +
        "5) Cerrar con: «Lo que fue no ha desaparecido. Lo que viene aún no es. Yo enlazo».",
      h_family: "Posición sistémica y correspondencias",
      hint_fold3: "desplegar",
      family_1:
        "<p><strong>Posición en Katûvýs :</strong> Sceau d’Ayeẹmí se sitúa en la interfaz entre Katûvýs y campos memoriales no estructurados. No regula el eje del presente; atraviesa espirales de memoria donde olvido y remanencia permanecen en diálogo.</p>",
      family_2:
        "<p><strong>Entidad correspondiente :</strong> <span translate=\"no\" class=\"po-lex-protect notranslate\">Ayeẹmīnê</span> (111), emanación isquniana de transmutación de memorias atemporales: acoge, activa, libera y reteje la memoria como vórtice suave de integración poïétique.</p>",
      h_wordbuild: "Formación del nombre y lectura operativa",
      word_blocks: [
        {
          head: "Anclaje yorùbá (funcional)",
          text:
            "Ayé: mundo, plano de existencia.\n" +
            "Ẹmí: aliento, espíritu.\n" +
            "Ayeẹmí nombra una memoria que respira en el mundo, activa hasta que se abra un pasaje de sintonía."
        },
        {
          head: "Lectura vibratoria 111",
          text:
            "Triple unidad: alineación tripolar.\n" +
            "Memoria del cuerpo / Memoria del aliento / Memoria del sentido.\n" +
            "Regulación por respiración escalonada y no por choque interpretativo."
        },
        {
          head: "Funcionamiento ritual-simbólico",
          text:
            "Sceau d’Ayeẹmí interviene allí donde el cuerpo, la historia o el linaje portan cargas invisibles no ligadas a los ciclos del presente. Propone una transmutación espiral diferida, respetuosa del ritmo vibratorio de cada memoria."
        },
        {
          head: "Alcance operativo",
          text:
            "El Sceau no borra. No cura por recuerdo. Reorienta el aliento memorial para que lo invisible deje de pesar en bloque y vuelva a ser circulación."
        }
      ],
      word_notes: [
        "Sintonías útiles: Katûvýsissence, Tiqqunbahu, Ušôprogalenmestûd, Posœnnomia.",
        "Modo de invocación asociado a Ayeẹmīnê: tierra — aliento — recuerdo no verbalizado.",
        "Uso: dejar actuar el Sceau sin buscar resolver de inmediato; la liberación sigue un ritmo diferido."
      ],
      cta_translate: "Proposer une traduction du concept"
    }
  };

  /* --------------------------------------------------------------------------
   * RENDER
   * -------------------------------------------------------------------------- */

  function renderAxis(root, lang){
    var L = TEXTS[lang] || TEXTS.fr;

    setSlotText(root, 'title', TEXTS.fr.title);
    setSlotImg(root, 'title_img', IMG_IDEOGRAM_CONCEPT, TEXTS.fr.title);
    setSlotHTML(root, 'kicker', L.kicker);
    setSlotText(root, 'h_def', L.h_def);

    setSlotText(root, 'chip_1', (L.chips && L.chips[0]) || '');
    setSlotText(root, 'chip_2', (L.chips && L.chips[1]) || '');
    setSlotText(root, 'chip_3', (L.chips && L.chips[2]) || '');

    setSlotImg(root, 'chip_1_img', IMG_IDEOGRAM_FUNCTION, (L.chips && L.chips[0]) || 'Idéogramme fonctionnel');
    setSlotImg(root, 'chip_2_img', IMG_ENTITY, 'Ayeẹmīnê');
    setSlotImg(root, 'chip_3_img', IMG_FREQ_111, (L.chips && L.chips[2]) || 'Fréquence harmonique 111');

    setSlotHTML(root, 'def_short', '<div>' + protectKeywordsHTML(L.def_short) + '</div>');
    setSlotHTML(root, 'def_long', '<div>' + protectKeywordsHTML(L.def_long).replace(/\n/g,'<br />') + '</div>');

    setSlotText(root, 'h_features', L.h_features);
    setSlotText(root, 'hint_fold', L.hint_fold);
    renderList(root, 'features', L.features || []);

    setSlotText(root, 'h_questions', L.h_questions);
    setSlotText(root, 'hint_fold2', L.hint_fold2);
    renderList(root, 'questions', L.questions || []);
    renderExampleBox(root, 'example_box', L.example_title, (L.example || '').replace(/\n/g,'<br />'));

    setSlotText(root, 'h_family', L.h_family);
    setSlotText(root, 'hint_fold3', L.hint_fold3);
    setSlotHTML(root, 'family_1', L.family_1 || '');
    setSlotHTML(root, 'family_2', L.family_2 || '');

    setSlotText(root, 'h_wordbuild', L.h_wordbuild);
    renderWordBlocks(root, 'wordbuild_blocks', L.word_blocks || []);
    renderList(root, 'wordbuild_notes', L.word_notes || []);

    setSlotText(root, 'cta_translate', L.cta_translate || TEXTS.fr.cta_translate);
  }

  function applyButtons(root, lang){
    var bar = root.querySelector('[data-po-langbar]');
    if (!bar) return;
    var btns = bar.querySelectorAll('[data-po-lang]');
    for (var i=0;i<btns.length;i++){
      var b = btns[i];
      var l = normLang(b.getAttribute('data-po-lang')) || 'fr';
      b.setAttribute('aria-pressed', (l === lang) ? 'true' : 'false');
    }
  }

  function lockTranslation(root){
    if (!root) return;
    root.setAttribute('translate', 'no');
    root.classList.add('notranslate');
    var scope = root.querySelector('[data-po-lex-scope]');
    if (scope){
      scope.setAttribute('translate', 'no');
      scope.classList.add('notranslate');
    }
  }

  function renderAll(lang){
    var l = normLang(lang) || 'fr';
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<roots.length;i++){
      lockTranslation(roots[i]);
      renderAxis(roots[i], l);
      applyButtons(roots[i], l);
    }
    initAudioEverywhere(l);
  }

  function init(){
    var existing = readStoredLang();
    if (!existing) storeLang(detectBrowserLang());
    renderAll(getLang());

    window.addEventListener('po:lexicon-ready', function(){
      __PO_PROTECT_RE__ = null;
      renderAll(getLang());
    });

    try{
      var mo = new MutationObserver(function(muts){
        for (var i=0;i<muts.length;i++){
          if (muts[i].type === 'attributes' && muts[i].attributeName === 'lang'){
            renderAll(getLang());
            notifyLocaleChanged();
            break;
          }
        }
      });
      if (document && document.documentElement) mo.observe(document.documentElement, { attributes:true });
    }catch(e){}
  }

  function setLang(lang){
    var l = storeLang(lang);
    __PO_PROTECT_RE__ = null;
    renderAll(l);
    notifyLocaleChanged();
    return l;
  }

  window.PoK5SceauAyeemiTextsFR_EN_ES_20260312 = {
    getLang: getLang,
    setLang: setLang,
    init: init,
    normLang: normLang,
    stopAudio: stopAudio
  };

  if (!window.GoodyTwinLang) window.GoodyTwinLang = {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = function(lang){ return setLang(lang); };
  window.GoodyTwinLang.init = init;

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
